import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppLayoutService } from '../../app-layout.service';
import { IHeaderStatus } from '../../interfaces';

@Component({
  selector: 'app-header-status',
  templateUrl: './header-status.component.html',
  styleUrls: ['./header-status.component.scss'],
})
export class HeaderStatusComponent implements OnInit, OnDestroy {
  public status: IHeaderStatus;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private appLayoutService: AppLayoutService) {}

  public ngOnInit(): void {
    this.appLayoutService.headerStatus$.pipe(takeUntil(this.isDestroy)).subscribe((status) => (this.status = status));
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }
}
